import { IACDLEvent } from '../../../../../__legacy__/services/eventBus.service';

export const ProjectExportStartedEventType = Symbol('PROJECT_EXPORT_STARTED_EVENT');

export class ProjectExportStartedEvent implements IACDLEvent {
  constructor(public readonly projectId: string) {}

  readonly type: symbol = ProjectExportStartedEventType;
}
